var React = require('react');

function Browser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.095 2.38495C0.495 2.38495 0 2.86495 0 3.47995V6.20995H24V3.47995C24 2.87995 23.52 2.38495 22.905 2.38495H1.095ZM1.905 3.47995C2.355 3.47995 2.73 3.83995 2.73 4.30495C2.73 4.76995 2.37 5.12995 1.905 5.12995C1.44 5.12995 1.08 4.76995 1.08 4.30495C1.08 3.83995 1.44 3.47995 1.905 3.47995ZM4.635 3.47995C5.085 3.47995 5.46 3.83995 5.46 4.30495C5.46 4.76995 5.1 5.12995 4.635 5.12995C4.17 5.12995 3.81 4.76995 3.81 4.30495C3.81 3.83995 4.17 3.47995 4.635 3.47995ZM7.365 3.47995C7.815 3.47995 8.19 3.83995 8.19 4.30495C8.19 4.76995 7.83 5.12995 7.365 5.12995C6.9 5.12995 6.54 4.76995 6.54 4.30495C6.54 3.83995 6.9 3.47995 7.365 3.47995ZM0 8.11505V21.6151H24V8.11505H0Z","fill":"currentColor"}));
}

Browser.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Browser;

Browser.default = Browser;
